import { useRef, useEffect } from "react";
import * as d3 from "d3";

const WIDTH = 400;
const HEIGHT = 280;
const CX = WIDTH / 2;
const CY = HEIGHT / 2;
const RADIUS = 95;

function midAngle(d) {
  return d.startAngle + (d.endAngle - d.startAngle) / 2;
}

export const PieChart = ({ data }) => {
  const svgRef = useRef();

  useEffect(() => {
    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove();

    const g = svg.append("g").attr("transform", `translate(${CX},${CY})`);

    const pie = d3
      .pie()
      .value((d) => d.value)
      .sort(null);
    const arc = d3.arc().innerRadius(0).outerRadius(RADIUS);
    const arcHover = d3
      .arc()
      .innerRadius(0)
      .outerRadius(RADIUS + 8);
    const outerArc = d3
      .arc()
      .innerRadius(RADIUS * 1.2)
      .outerRadius(RADIUS * 1.2);

    const arcs = pie(data);

    // slices
    g.selectAll("path")
      .data(arcs)
      .join("path")
      .attr("d", arc)
      .attr("fill", (d) => d.data.color)
      .style("cursor", "pointer")
      .on("mouseenter", function () {
        d3.select(this).transition().duration(150).attr("d", arcHover);
      })
      .on("mouseleave", function () {
        d3.select(this).transition().duration(150).attr("d", arc);
      });

    // value labels inside slices
    g.selectAll(".val-label")
      .data(arcs.filter((d) => d.data.value > 0))
      .join("text")
      .attr("class", "val-label")
      .attr("transform", (d) => `translate(${arc.centroid(d)})`)
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("font-size", 20)
      .attr("font-weight", "bold")
      .attr("fill", "black")
      .text((d) => d.data.value);

    // polylines + outside labels
    arcs
      .filter((d) => d.data.value > 0)
      .forEach((d) => {
        const isRight = midAngle(d) < Math.PI;
        const posA = arc.centroid(d);
        const posB = outerArc.centroid(d);
        const posC = [isRight ? RADIUS * 1.45 : -RADIUS * 1.45, posB[1]];
        const pointsStr = [posA, posB, posC].map((p) => p.join(",")).join(" ");

        g.append("polyline")
          .attr("points", pointsStr)
          .attr("fill", "none")
          .attr("stroke", "#555")
          .attr("stroke-width", 1);

        g.append("text")
          .attr("transform", `translate(${posC})`)
          .attr("text-anchor", isRight ? "start" : "end")
          .attr("dominant-baseline", "central")
          .attr("font-size", 14)
          .attr("fill", "#333")
          .text(d.data.label);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data)]);

  return (
    <svg
      ref={svgRef}
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      style={{ width: "100%", height: "auto" }}
    />
  );
};
